import React from "react";
import { Trans } from "react-i18next";

const CTRTwitter = ({ metricValue }) => {
  return (
    <Trans i18nKey={"ctr.twitter.greateNews"}>
      Great news — our Twitter CTR is at <b>{{ metricValue }}%</b>! 🌟 While it's encouraging to see
      some clicks, remember that on Twitter, likes and shares are the real game changers. Let's
      focus on boosting our visibility and engagement through these interactions to maximize our
      impact!
    </Trans>
  );
};

export default CTRTwitter;
